<template>
    <div class="dropdown" :class="{'dropdown--open': isOpen}" @click="toggleOpen">
        <div class="dropdown__selected">
            {{ hasValue ? value : placeholder }}
        </div>

        <div class="dropdown__unit" v-if="hasUnit && hasValue">
            {{ unit }}
        </div>

        <!-- Arrow -->
        <div class="dropdown__arrow" :class="{'dropdown__arrow--open': isOpen}">
            <svg height="9" viewBox="0 0 14 9" width="14" xmlns="http://www.w3.org/2000/svg">
                <path d="m1.645 0 5.355 5.34333333 5.355-5.34333333 1.645 1.645-7 7-7-7z"
                      fill="#023e84" transform="matrix(1 0 0 -1 0 8.645)"></path>
            </svg>
        </div>

        <div class="dropdown__menu" :class="{'dropdown__menu--open': isOpen}" v-if="hasOptions">
            <div class="dropdown__menu__option" :class="{'dropdown__menu__option--selected': option === value}" v-for="option in options" @click="$emit('input', option)" :key="option">
                {{ option }}<span class="dropdown__menu__option__unit" v-if="hasUnit">{{ ' ' + unit }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name:     "DropDownField",
        props:    {
            value:       {
                type: [String, Number],
            },
            options:     {
                type:     Array,
                required: true
            },
            placeholder: {
                type:    String,
                default: function () {
                    return 'Bitte wählen'
                }
            },
            unit:        {
                type:    String,
                default: function () {
                    return ''
                }
            },
            unitMobile: {
                type:    String,
                default: function () {
                    return ''
                }
            }
        },
        data:     function () {
            return {
                isOpen: false
            }
        },
        computed: {
            hasValue: function () {
                return this.value !== null
            },

            hasOptions: function () {
                return this.options !== null
            },

            hasUnit: function () {
                return this.unit !== ''
            },

            filteredOptions: function () {
                return this.options.filter(option => option !== this.value)
            }
        },
        methods:  {
            toggleOpen: function () {
                this.isOpen = !this.isOpen;
            }
        }
    }
</script>


<style scoped>

</style>
